var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeminaLogo = function SvgFeminaLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 149 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m139.719 0-14.184 21.012V0h-9.265v15.967L105.22 0h-8.55v33.577h9.375V17.095l11.781 16.485h9.746l2.838-4.299h9.051v4.296h9.105V0h-8.847Zm-.261 21.602h-4.182l4.185-6.225-.003 6.225Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M85.477 0h8.14v33.58h-8.14V0Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.37 0h19.123v8.398h-9.935v4.188h9.935v8.052h-9.935v4.617h7.905L55.93 0h8.174v16.074L74.947 0h8.494v33.58H74.36V15.916L62.288 33.58h-7.052V15.699L43.104 33.58H21.369V0Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 0h19.334v8.398H9.369v4.188h9.965v8.052H9.369V33.58H0V0Z",
    clipRule: "evenodd"
  })));
};
export default SvgFeminaLogo;